import axios, { AxiosError, type AxiosResponse } from 'axios'
import type { ApiResponse, AxiosDataResponse } from '../../../config/api-types'
import { AUTH_ENDPOINTS } from '../../../config/endpoints'
import type { IGetTimeClient } from '../data/data-sources/i-get-time-client'

export class GetTimeService implements IGetTimeClient {
  async getTime(): Promise<ApiResponse> {
    axios.defaults.baseURL = import.meta.env.VITE_REACT_APP_API_URL
    axios.defaults.headers.common['x-api-version'] = Number(
      import.meta.env.VITE_REACT_APP_API_VERSION,
    )

    try {
      const result: AxiosResponse<AxiosDataResponse> = await axios.get(
        AUTH_ENDPOINTS.getTime,
      )

      return {
        message: result.data?.message,
        data: result.data.data,
        status: result.status,
        success: result.data.success,
      }
    } catch (error) {
      const axiosError = error as AxiosError<AxiosDataResponse>

      return {
        success: false,
        status: axiosError.response?.status!,
        message: axiosError.response?.data?.message,
      }
    }
  }
}
